var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",class:{ on : _vm.showMenu },attrs:{"id":"app"}},[_c('div',{staticClass:"scroll"},[_c('header-box'),_c('home'),_c('keep-alive',[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }